import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
  palette: {
    primary: {
      light: '#24cca7',
      main: '#24cca7',
      dark: '#24cca7',
      contrastText: '#fff',
      gray: '#e7eaf2',
    },
    secondary: {
      light: '#4a56e2',
      main: '#4a56e2',
      dark: '#4a56e2',
      contrastText: '#fff',
    },
  },
});
